import { createInteractiveColorVars } from '../../helpers/createInteractiveColorVars/index.js';

const InformationColors = createInteractiveColorVars('information');
const InformationColorsLightValues = Object.freeze({
    base: {
        default: '#5A00EE',
        action: '#3D00A2',
        active: '#5A00EE',
        activeAction: '#3D00A2',
    },
    text: {
        default: '#ffffff',
        action: '#ffffff',
        active: '#ffffff',
        activeAction: '#ffffff',
    },
});
const InformationColorsDarkValues = Object.freeze({
    base: {
        default: '#BD99F8',
        action: '#8168A9',
        active: '#BD99F8',
        activeAction: '#8168A9',
    },
    text: {
        default: '#000000',
        action: '#000000',
        active: '#000000',
        activeAction: '#000000',
    },
});

export { InformationColors, InformationColorsDarkValues, InformationColorsLightValues };
